<template>
  <div id="listDetails">
    <div class="main">
        <div class="nav-bar">
          <div class="nav-bar-l">
            <img style="margin-right:5px" src="../../assets/image/back.png" alt="" @click="$router.back()">
            <p>建筑垃圾</p>
          </div>
          <div class="nav-bar-r">
            <div style="position: relative;">日期选择
              <el-date-picker
                type="date"
                v-model="val"
                value-format="yyyy-MM-dd"
                @change="change1($event)"
                :clearable="false">
              </el-date-picker>
            </div>
            <el-dropdown trigger="click">
              <div class="el-dropdown-link">
                站点选择
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>A站点</el-dropdown-item>
                <!-- <el-dropdown-item>B站点</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown trigger="click">
                <div class="el-dropdown-link">
                  状态选择
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>开启</el-dropdown-item>
                  <el-dropdown-item>关闭</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
          </div>
        </div>
         <div class="box">
          <div class="title">
              <div class="title-item">
                序号
              </div>
              <div class="title-item">
                时间
              </div>
              <div class="title-item">
                站点
              </div>
              <div class="title-item">
                设备状态
              </div>
              <div class="title-item">
                实拍
              </div>
              <div class="title-item">
                限定面积
              </div>
              <div class="title-item">
                占用面积
              </div>
              <div class="title-item">
                监测情况
              </div>
            </div>
            <div class="scroll">
              <div class="content-i">
                <div class="content-item">1</div>
                <div class="content-item">2022-10-21</div>
                <div class="content-item">A站点</div>
                <div class="content-item">正常</div>
                <div class="content-item" style="padding: 4px;"><img style="width: 100%;height: 100%;" src="../../assets/image/rubbish.png"></div>
                <div class="content-item">80m²</div>
                <div class="content-item">65m²</div>
                <div class="content-item">正常</div>
              </div>
              <div class="content-i">
                <div class="content-item">2</div>
                <div class="content-item">2022-11-15</div>
                <div class="content-item">A站点</div>
                <div class="content-item">正常</div>
                <div class="content-item" style="padding: 4px;"><img style="width: 100%;height: 100%;" src="../../assets/image/rubbish2.png"></div>
                <div class="content-item">80m²</div>
                <div class="content-item">76m²</div>
                <div class="content-item">正常</div>
              </div>
              <div class="content-i">
                <div class="content-item">3</div>
                <div class="content-item">2022-11-18</div>
                <div class="content-item">A站点</div>
                <div class="content-item">正常</div>
                <div class="content-item" style="padding: 4px;"><img style="width: 100%;height: 100%;" src="../../assets/image/rubbish3.png"></div>
                <div class="content-item">80m²</div>
                <div class="content-item">70m²</div>
                <div class="content-item">正常</div>
              </div>
              <div class="textS" v-if="a.length===0">
              <!-- <span>暂无数据</span> -->
            </div>
            </div>
            <div class="fenye">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage4"
                  :page-sizes="[100, 200, 300, 400]"
                  :page-size="100"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="3">
                </el-pagination>
              </div>
        </div>
      </div>
  </div>
</template>

<script>
  export default {
    data:()=>{
      return {
        a:[]
      }
    }
  }
</script>

<style scoped>
.el-date-editor {
  position: absolute;
  left: 0;top: 0;
  width: 150px;
}
::v-deep .el-input__inner, ::v-deep .el-input__prefix{
  opacity: 0 !important;
  cursor: pointer;
}
.el-dropdown-menu, .el-popper{
  width: 150px;

}
.main{
  height: 90.7vh;
  background-color: #ecf0f5;
  padding-left:5px ;
  padding-right:23px ;
  display: flex;
  flex-direction: column;
}
.nav-bar{
  height: 57px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.nav-bar-l{
  display: flex;
  justify-content: center;
  align-items: center;
}
.nav-bar-r{
  width: 510px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.nav-bar-r>div{
  width: 150px;
  border: 0;
  background-color: #0b62f0;
	border-radius: 6px;
  color: #fff;
  height: 40;
  line-height: 40px;
  padding: 0 8px;
  cursor: pointer;
}

.box{
  overflow: hidden;
  border-radius: 10px;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.box-top{
  height: 60px;
  line-height: 60px;
  background-color: #D4D4D4;
}
.title, .content-i{
  display: flex;
}
.scroll{
  flex: 1;
  overflow: scroll;
}
.scroll::-webkit-scrollbar{
  width: 0 !important;
  height: 0 !important;
}
.title-item, .content-item{
  flex: 1;
  height: 50px;
  line-height: 50px;
  border: 1px solid #D4D4D4;
}
.title-item{
  color: black;
  background-color: #E6E6E6;
}
.content-item{
  height: 119px;
  line-height: 119px;
}
.content-i{
  background-color: #fff;
}
.content-i:hover{
  background-color: #e1edf8;
}
.fenye .el-pagination{
  background-color: #E6E6E6;
  /* background-color: #f00; */
}
.textS{
  background-color: #fff;
  height: 74vh;
  display: flex;
  justify-content: center;
}
.textS>span{
  font-size: 26px;
  margin-top: 5vh;
}
</style>
